import { observer } from 'mobx-react-lite';
import { useStoreUIV1 } from '../../hooks/useStore.hook';
import './debug.component.scss';

export declare namespace DebugType {
  type Props = {
    config: {
      active: boolean;
    };
  };
}

export const Debug = observer(({ config: { active } }: DebugType.Props) => {
  const { I18NStore } = useStoreUIV1();

  return null;
});
